import React from "react";
import CssClasses from "./CalendarHourButton.css";
import SiteIcons from "../../../assets/fonts/site_icons/style.css";

const CalendarDayButton = props => {
  let classes = [CssClasses.button];

  if (props.isActive) {
    classes.push(CssClasses.active);
  }

  return (
    <div
      onClick={() => {
        props.onButtonClicked(props.id);
      }}
      className={classes.join(" ")}
    >
      <span
        className={[SiteIcons.site_icon_clock, CssClasses.clockIcon].join(" ")}
      />
      <span className={CssClasses.hour}>{props.hour}h</span>
    </div>
  );
};

export default CalendarDayButton;



// WEBPACK FOOTER //
// ./src/Components/UI/CalendarHourButton/CalendarHourButton.js